export default __webpack_public_path__ + "static/media/web.15d6bd08.svg";